import { render, staticRenderFns } from "./EditAdminProfile.vue?vue&type=template&id=72048844"
import script from "./EditAdminProfile.vue?vue&type=script&lang=js"
export * from "./EditAdminProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports